import { icons } from '@1debit/chime-assets';
import { getIconByKey, IconToken } from '@1debit/icons';
import { datadogRum } from '@datadog/browser-rum';
import { pascalToSnake } from 'utils/formatters';
import { PropsWithClass } from 'types/sharedComponents';

interface ChimeKitIconProps extends PropsWithClass {
  iconName: string;
  width?: number;
  height?: number;
  testId?: string;
}
const ChimeKitIcon = ({ iconName, testId, ...rest }: ChimeKitIconProps) => {
  const realIconName = pascalToSnake(iconName);

  const testFixture = testId ?? 'chimekit-icon';

  if (!(realIconName in icons)) {
    datadogRum.addError(`LinkedIcon Error: ${realIconName} is not a valid Icon.`);
    return null;
  }

  const Icon = getIconByKey(realIconName as IconToken);

  return <Icon data-testid={testFixture} {...rest} />;
};

export default ChimeKitIcon;
